import { Injectable } from "../reflection/injectable";

// Safari lanza SecurityError al acceder a localStorage si el usuario bloquea las cookies
@Injectable({ type: 'singleton' })
export class LocalStorageService {

    public constructor() {        
    }

    public set(key: string, value: any): void {
        try {
            window.localStorage.setItem(key, value != null ? JSON.stringify(value): null);
        } 
        catch (error) {
            console.warn(`LocalStorageService: no se ha podido guardar "${key}"`, error);
        }
    }

    public get(key: string): any {
        try {
            const value: string = window.localStorage.getItem(key);
            return value ? JSON.parse(value): null;
        } 
        catch (error) {
            console.warn(`LocalStorageService: no se ha podido leer "${key}"`, error);
            return null;
        }
    }

    public remove(key: string): void {
        try {
            window.localStorage.removeItem(key);
        } 
        catch (error) {
            console.warn(`LocalStorageService: no se ha podido eliminar "${key}"`, error);
        }
    }
}
